<template>
  <div class="m-pagination-wrapper">
    <div>
      <span>
        <span :class="['m-icon-prev', { 'is-disabled': !hasPrev }]" @click="goPrev"></span>
      </span>
      <span>
        <span>{{ current }}</span>
        <span class="m-total">/ {{ total }}</span>
      </span>
      <span>
        <span :class="['m-icon-next', { 'is-disabled': !hasNext }]" @click="goNext"></span>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Pagination extends Vue {
  @Prop({ default: 0 }) readonly total!: number;
  @Prop({ default: 1 }) readonly current!: number;

  get hasPrev() {
    return this.current > 1;
  }
  get hasNext() {
    return this.current < this.total;
  }

  goPrev() {
    if (this.hasPrev) {
      this.$emit('changePage', this.current - 1);
    }
  }
  goNext() {
    if (this.hasNext) {
      this.$emit('changePage', this.current + 1);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
.m-pagination-wrapper {
  div {
    width: 100%;
    text-align: center;
  }

  span {
    font-size: 16px;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    color: $pagination-text-color;
    font-weight: bold;
  }

  .m-total {
    font-weight: normal;
  }

  .m-icon-prev,
  .m-icon-next {
    display: flex;
    align-items: center;
    cursor: pointer;
    &:before {
      border-style: solid;
      border-width: 0.1em 0.1em 0 0;
      content: '';
      display: inline-block;
      height: 0.6em;
      transform: rotate(-45deg);
      width: 0.6em;
    }
  }

  .m-icon-next {
    margin-left: 32px;
    &:before {
      transform: rotate(45deg);
    }
    &.is-disabled {
      opacity: 0.4;
      cursor: auto;
    }
  }

  .m-icon-prev {
    margin-right: 32px;
    &:before {
      transform: rotate(-135deg);
    }
    &.is-disabled {
      opacity: 0.4;
      cursor: auto;
    }
  }
}
</style>
